export default "__VITE_ASSET__016423ce__"